<template>
  <div class="gerar-carta-proposta-inicio">
    <g-card :temCabecalho="false">
      <div class="container-form">
        <img class="card-proposta-img" src="@/assets/imgs/icone_carta_proposta.svg"/>

        <div class="titulo-inicio-fluxos"> Gerar Carta-Proposta </div>
        <div class="subtitulo-fluxos"> Selecione a unidade, o representante e o cliente </div>

          <g-form>
            <div class="container-inputs espacamento-inicio-fluxos">
              <div class="produto-novo-unidade">
                <div class="titulo-conteudo-filtros"> Unidade <strong class="asterisco-obrigatorio">*</strong></div>
                <PDropDown
                  class="input-unidade"
                  v-model="EmpresaSelecionada"
                  :options="EmpresaArray"
                  optionLabel="nome"
                  optionValue="id"
                  placeholder="Selecione a Unidade"
                  :filter="true"
                  @change="zerarcampos"
                />
              </div>

              <div class="produto-novo-representante">
                <div class="titulo-conteudo-filtros"> Representante <strong class="asterisco-obrigatorio">*</strong></div>
                <PDropDown
                  v-model="RepresentanteSelecionado"
                  :options="RepresentantesArray"
                  optionLabel="codigoNomeRepresentante"
                  optionValue="representanteId"
                  @filter="buscarRepresentante($event.value)"
                  :filter="true"
                  placeholder="Selecione o Representante"
                  @change="ClientesArray = []"
                />
              </div>

              <div class="produto-novo-cliente">
                <div class="titulo-conteudo-filtros">Cliente <strong class="asterisco-obrigatorio">*</strong></div>
                <!-- <PDropDown
                  class="input-cliente"
                  v-model="ClienteSelecionado"
                  :options="ClientesArray"
                  :filterFields="['razaoSocial','codigoExterno','nomeFantasia','situacao','estadoCidade','cnpj']"
                  optionLabel="nomeFantasia"
                  optionValue="id"
                  placeholder="Selecione o Cliente"
                  :filter="true"
                  @filter="buscarClientes($event.value)"
                >
                  <template #option="slotProps">
                    <cliente-dropdown-item :dadosCliente="slotProps.option"></cliente-dropdown-item>
                  </template>
                </PDropDown> -->
                <cliente-dropdown
                  class="p-dropdown cliente"
                  v-model="ClienteSelecionado"
                  :empresaId="EmpresaSelecionada"
                  :representanteId="RepresentanteSelecionado"
                />
              </div>
            </div>
          </g-form>
          <div class="alinha-button-fluxo">
            <div class="button-fluxo">
              <g-button
              tipo="amarelo" 
              negritoTexto 
              altura="35px"
              largura="100%"
              @click="Continuar"
              >
                <div v-if="escritobotao">CONTINUAR</div>
                <div v-if="!escritobotao" class="pi pi-spin pi-spinner"></div>
              </g-button>
            </div>
          </div>
      </div>
    </g-card>
  </div>
</template>

 <script>
import GerarCartaPropostaInicio from "./GerarCartaPropostaInicio.js";
export default GerarCartaPropostaInicio;
</script>


 <style scoped>
 .largura-maxima{
  margin-top: 80px
 }

.text-left {
  text-align: initial;
}


:deep(.custom-p-input) {
  width: 100%;
}

.input-unidade,
.input-cliente,
.input-representante {
  width: 100%;
}

.container-inputs {
  margin-bottom: 50px;
}

.form-carta-inicio {
  width: 90%;
  margin: 0 auto;
}

.input-label {
  margin-bottom: 10px;
}

/* --------------------------------- */

.Titulo-Inicial {
  text-align: center;
  font: normal normal 600 20px/31px Montserrat;
  color: #4f2c19;
  opacity: 1;
  /* margin-top: 10px;; */
}
.Subtitulo-Inicial {
  text-align: center;
  font: normal normal normal 12px/19px Montserrat;
  color: #8a8a8a;
  opacity: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.container-subtitulo {
  margin: 0 auto;
  width: 80%;
}

.proposta-img-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.card-proposta-img {
  width: 149.33px;
}
.campos-gerar-proposta-select {
  width: 87%;
  /* margin-left: 6%; */
  height: 35px;
}

.campos-gerar-proposta-autocomplete {
  width: 110%;
  /* margin-left: 2%; */
  height: 37px;
}
.button-continuar {
  margin: 50px auto 0 auto;
}

.margim-campos {
  /* margin-left: 2%;
   margin-top: 12px;
   margin-bottom: 12px; */
  font: normal normal 600 13px/19px Montserrat;
  width: 30%;
  color: #707070;
  opacity: 1;
}

.margim-campos-cliente {
  /* margin-left: 3%;
   margin-top: 12px;
   margin-bottom: 12px; */
  font: normal normal 600 13px/19px Montserrat;
  width: 10%;
  color: #707070;
  opacity: 1;
}

.margim-campo-unidade {
  /* margin-left: 3%;
   margin-top: 12px;
   margin-bottom: 12px; */
  font: normal normal 600 13px/19px Montserrat;
  width: 10%;
  color: #707070;
  opacity: 1;
}

.botao {
  display: flex;
  justify-content: center;
}

@media (min-width: 310px) {
  .container-form {
    margin-top: 60px;
  }
}

@media (min-width: 368px) {
  :deep(.g-card-conteudo) {
    padding-bottom: 50px;
  }
}

@media (min-width: 600px) {
  .container-inputs {
    display: grid;
    grid-template-columns: repeat(2, minmax(4em, 1fr));
    grid-column-gap: 20px;
  }
  .produto-novo-unidade {
    grid-area: 1 / 1 / 2 / 3;
  }
  .produto-novo-representante {
    grid-area: 2 / 1 / 3 / 2;
  }
  .produto-novo-cliente {
    grid-area: 2 / 2 / 3 / 3;
  }
}

@media (min-width: 801px) {
}

@media (min-width: 1025px) {
  .container-form {
    margin-top: 80px;
  }

  .input:first-child {
    width: 100%;
  }

  .input:nth-child(2) {
    /* width: 50%; */
    flex: 1;
  }

  .input:nth-child(3) {
    /* width: 50%; */
    flex: 1;
  }
}

@media (min-width: 1281px) {
  .Subtitulo-Inicial {
    font: normal normal normal 13px/19px Montserrat;
    letter-spacing: 0px;
    /* margin-left: -2%; */
    color: #8a8a8a;
    opacity: 1;
  }


}

@media (min-width: 1400px) {
  .Subtitulo-Inicial {
    font: normal normal normal 13px/19px Montserrat;
    letter-spacing: 0px;
    /* margin-left: -2%; */
    color: #8a8a8a;
    opacity: 1;
  }

}
</style>
